import {CircularProgress, Grid} from "@mui/material";

export const Loading = () => {
    return <Grid padding={"2em"} container justifyContent="center"><CircularProgress/></Grid>
}